<div v-bind:class="getClassName">
    <div
        v-bind:class="getClassNameContainer"
        v-for="(item,index) in getSummary"
        v-bind:key="index">
        <div v-bind:class="getClassName + 'Header'" v-if="item.name">
        {{item.name}}
        </div>
        <div
            v-bind:class="getClassNameItem"
            v-for="(attribute,index) in item.data"
            v-bind:key="index">
            {{index}} - {{attribute}}
        </div>
    </div>
</div>

